var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.data ? _c('section', {
    staticClass: "sidebar-view-payment"
  }, [_c('b-sidebar', {
    staticClass: "detail-sidebar",
    attrs: {
      "bg-variant": "white",
      "right": "",
      "backdrop": "",
      "shadow": "",
      "no-header": "",
      "width": "60%"
    },
    on: {
      "hidden": function ($event) {
        return _vm.$emit('update:isShow', false);
      }
    },
    model: {
      value: _vm.isShow,
      callback: function ($$v) {
        _vm.isShow = $$v;
      },
      expression: "isShow"
    }
  }, [_c('div', {
    staticClass: "sidebar-view-payment__header d-flex"
  }, [_c('div', {
    staticClass: "sidebar-view-payment__header--title w-50"
  }, [_c('h4', {
    staticClass: "mb-0 p-1 text-primary text-truncate"
  }, [_vm._v(" " + _vm._s(_vm.$t("ar_client_detail_receipt")) + " ")])]), _c('div', {
    staticClass: "sidebar-view-payment__header--icon w-50 d-flex align-items-center justify-content-end"
  }, [_c('ez-icon', {
    staticClass: "cursor-pointer mx-50",
    attrs: {
      "icon": "ezAr-icon-x",
      "size": "24",
      "color": "#114A9F"
    },
    on: {
      "click": _vm.closeSidebar
    }
  })], 1)]), _c('b-tabs', {
    model: {
      value: _vm.tabIndex,
      callback: function ($$v) {
        _vm.tabIndex = $$v;
      },
      expression: "tabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": _vm.$t('ar_voucher_general_information')
    }
  }, [_c('b-row', {
    staticClass: "m-0 mb-1"
  }, [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('h6', {
    staticClass: "content-title"
  }, [_vm._v(" " + _vm._s(_vm.$t("ar_voucher_general_information")) + " ")])]), _c('b-col', {
    staticClass: "d-flex justify-content-end",
    attrs: {
      "md": "6"
    }
  }, [_c('ez-icon', {
    staticClass: "cursor-pointer mx-50",
    class: {
      'd-none': !_vm.isValidPermission(_vm.AR_UPA01)
    },
    attrs: {
      "icon": "ezAr-icon-edit",
      "size": "24",
      "color": "#114A9F"
    },
    on: {
      "click": _vm.showModalEditAddNew
    }
  })], 1)], 1), _c('GeneralInfo', {
    attrs: {
      "leftWidth": "120px",
      "rightWidth": "140px",
      "list": _vm.listGeneral
    }
  }), _c('div', {
    staticClass: "divider"
  }), _c('div', {
    staticClass: "d-flex align-items-center justify-content-between"
  }, [_c('h6', {
    staticClass: "m-1"
  }, [_vm._v(_vm._s(_vm.$t("ar_client_list_payment")))]), _c('div', {
    staticClass: "mr-1 d-flex align-items-center"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": true
    }
  }, [_vm._v(_vm._s(_vm.$t("ar_client_print_payment")))]), _c('PermissionButton', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "api-code": _vm.AR_IPAD01,
      "variant": "primary"
    },
    on: {
      "click": _vm.showModalAddNew
    }
  }, [_c('ez-icon', {
    attrs: {
      "icon": "ezAr-icon-plus-circle"
    }
  }), _c('span', {
    staticStyle: {
      "margin-left": "3px"
    }
  }, [_vm._v(_vm._s(_vm.$t("ar_client_add_pay")))])], 1)], 1)]), _c('div', {
    staticClass: "p-1"
  }, [_c('EzTable', {
    attrs: {
      "externalLoading": _vm.isDetailPaymentLoading,
      "actions": _vm.actions,
      "toolbarConfig": {
        disableToolbar: true
      },
      "dataSource": _vm.convertedListArPaymentDetail,
      "columns": _vm.columns,
      "pageConfig": {
        disablePagination: true
      }
    },
    on: {
      "action-1": function (data) {
        return _vm.editListPaymentAr(data.data.Id);
      },
      "action-2": function (data) {
        return _vm.$emit('del-ListArPaymentDetail', data.data.Id);
      }
    }
  })], 1)], 1), _vm.isValidPermission(_vm.AR_HSP01) ? _c('b-tab', {
    attrs: {
      "title": _vm.$t('ar_client_operation_history')
    }
  }, [_c('div', {
    staticClass: "m-3"
  }, [_c('div', {
    staticClass: "mb-3 d-flex align-items-center"
  }, [_c('b-form-group', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "label": _vm.$t('ar_common_range')
    }
  }, [_c('WidgetDateTime', {
    attrs: {
      "placeholder": _vm.$t('ar_common_range'),
      "isRange": true
    },
    model: {
      value: _vm.range,
      callback: function ($$v) {
        _vm.range = $$v;
      },
      expression: "range"
    }
  })], 1), _c('b-button', {
    staticClass: "ml-2",
    staticStyle: {
      "margin-top": "16px"
    },
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function ($event) {
        var _vm$range, _vm$range2;
        return _vm.fetchPaymentHistory({
          FromDate: (_vm$range = _vm.range) === null || _vm$range === void 0 ? void 0 : _vm$range.startDate,
          ToDate: (_vm$range2 = _vm.range) === null || _vm$range2 === void 0 ? void 0 : _vm$range2.endDate
        });
      }
    }
  }, [_c('ez-icon', {
    staticStyle: {
      "margin-right": "3px"
    },
    attrs: {
      "icon": "ezAr-icon-search"
    }
  }), _vm._v(" Tìm kiếm ")], 1)], 1), _c('div', {
    staticClass: "p-1",
    staticStyle: {
      "height": "70vh",
      "overflow-y": "auto"
    }
  }, [_vm.limitedListPaymentHistory && _vm.limitedListPaymentHistory.length > 0 ? _c('AppTimeline', _vm._l(_vm.limitedListPaymentHistory, function (_ref, index) {
    var OldValue = _ref.OldValue,
      TransactionType = _ref.TransactionType,
      TransactionDate = _ref.TransactionDate,
      NewValue = _ref.NewValue,
      CashierName = _ref.CashierName,
      CreatedBy = _ref.CreatedBy;
    return _c('AppTimelineItem', {
      key: index,
      attrs: {
        "variant": _vm.convertedTransaction(TransactionType),
        "time": _vm.dayjs(TransactionDate).format('DD/MM/YYYY HH:mm:ss'),
        "subtitle": ((_vm.$t('ar_client_old_value')) + ": " + (_vm.formatPrice(OldValue))),
        "subtitle2": ((_vm.$t('ar_client_new_value')) + ": " + (_vm.formatPrice(NewValue))),
        "subtitle3": ((_vm.$t('ar_client_update_user')) + ": " + CreatedBy),
        "title": _vm.$t(_vm.convertTransactionType(TransactionType))
      }
    });
  }), 1) : _c('div', {
    staticClass: "d-flex justify-content-center mt-5",
    staticStyle: {
      "font-size": "20px",
      "color": "#ccc"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("ar_client_no_data")) + " ")]), _c('div', {
    staticClass: "d-flex justify-content-center mt-3"
  }, [_vm.limitedListPaymentHistory.length < _vm.listPaymentHistory.length ? _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.showMoreHistory
    }
  }, [_vm._v(_vm._s(_vm.$t("ar_client_show_more")))]) : _vm._e()], 1)], 1)])]) : _vm._e()], 1), _c('PaymentForDistribution', {
    attrs: {
      "api-code": _vm.AR_UPAD01,
      "isUpdate": _vm.isUpdate,
      "isShow": _vm.isShowModalPayment,
      "dataPayment": _vm.dataRefillForBill,
      "paymentId": _vm.data.Id
    },
    on: {
      "update:isShow": function ($event) {
        _vm.isShowModalPayment = $event;
      },
      "update:is-show": function ($event) {
        _vm.isShowModalPayment = $event;
      },
      "accept-data": _vm.acceptDataSaveForBill,
      "accept-data-edit": _vm.acceptDataEditForBill
    }
  })], 1)], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }